<template>
    <div class="disconnected center flex" v-if="!connected">
        <div class="overlay" />
        <div class="message">{{ 'DISCONNECTED' | translate }}</div>
        <button @click="reconnect" class="btn btn-primary flex-wrap">{{ 'RECONNECT' | translate }}</button>
    </div>
</template>

<script>
export default {
    computed: {
        connected() {
            return this.$store.getters.connected
        },
    },
    mounted() {
        this.reconnect()
    },
    methods: {
        reconnect() {
            this.$bus.$emit('onRequestReconnect')
        },
    },
}
</script>
